export default __webpack_public_path__ + "static/media/00daada3171025bb0b5c2d832aff50031602889928991.1fbefda2.webp";